import { formatMoney } from '../../../utils';

export const getSubTitle = (minPrice: number | string | undefined, maxPrice: number | string | undefined): string | undefined => {
  const min = parseFloat(String(minPrice));
  const max = parseFloat(String(maxPrice));
  if (!(min > 0) || !(max > 0)) return undefined;

  if (min === max) {
    return `$${formatMoney(min)}`;
  }
  return `$${formatMoney(min)} - $${formatMoney(max)}`;
};
